import React, { Component } from 'react';
import { Container, HeaderText } from '../../../components';
import TermsOfUseText from './termsOfUse';

class TermsOfUse extends Component {
  render() {
    return (
      <Container height="h-168" width="w-160" padding="px-20 py-8" className="flex flex-col" margin="mx-auto">
        <center>
          <HeaderText noBold fontSize="text-4xl" className="mt-2 mb-4">
            Terms of Use
          </HeaderText>
        </center>
        <br />
        <p className="overflow-y-auto">
          <TermsOfUseText />
        </p>
        <br />
      </Container>
    );
  }
}

export default TermsOfUse;
